// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__19nCR","sendOtp":"AuthorizeToLogin_sendOtp__3iNoN"};